module.exports = __webpack_public_path__ + "img/42600.08911ef5.jpg";